module.exports = __webpack_public_path__ + "img/logo.0905d3b5.png";